import {APIv1} from "../../api";

export async function deleteSavedCompany({companyInn, token, isMarket}) {
    const finalToken = token || JSON.parse(localStorage.getItem('user'))?.token;

    const body = {
        company_inn: companyInn,
    };

    let url = isMarket ? '/save/company/market/delete/' : '/save/company/delete/'
    const response = await APIv1.delete(url, {
        headers: {
            Authorization: `Token ${finalToken}`,
            'Content-Type': 'application/json',
        },
        data: body,
    });

    return response.status === 200 || response.status === 201;
}
